import React from 'react';
import logoHeader from '../../resource/img/logoHeader.png';
import iconSiguiente from '../../resource/svg/iconSiguiente.svg';
import icon2 from '../../resource/img/icon2.png';
import profile from '../../resource/img/ic_profile.svg';
import chevrot from '../../resource/img/chevrot.svg';


const Header = ({isLogin,usuario, username, onClick, onClickMenuMobile, classMostrarDropdown = '', isActive,  irFlujo}) => 
        <header id="Scrollspy"  className="d-flex justify-content-center">
            <div className="container d-flex mb-justify-content-center">
                <div className="container-header d-flex justify-content-start align-items-center w100 mb-w90">
                    <img className="logoHeader" src={logoHeader} alt="" />
                    {
                    !isLogin ?  null : 
                    <>
                    <div className="d-flex justify-content-end align-items-center w100 mb-w90">
                        <div  className="d-flex navHeader mb-display-none justify-content-around align-items-center ">
                        {
                        Object.values(localStorage.getItem("permisos") ? JSON.parse(localStorage.getItem("permisos")) : "").map((p,key) => {
                            return ( <>
                                    <div className="ul pointer">                           
                                        <p onClick={p.path?()=> irFlujo(p.path):null}>{p.nombre}</p> 
                                        {
                                        p.submenu &&                                      
                                        <div  className="mb-display-none justify-content-around align-items-center pointer">
                                        {p.submenu.map((p2,key2) => {
                                            return ( <>                         
                                                    <p onClick={()=> irFlujo(p2.path)}>{p2.nombre}</p>
                                                    
                                                    </>                                                   
                                                    );
                                            })
                                            }
                                        </div>                                  
                                        }             
                                    </div>                                      
                                    </>
                                    );
                        })}
                        </div>
                        <div className="d-flex navHeader mb-display-none justify-content-around align-items-center pointer">
                            
                            <a className='dropdown-trigger username' href='#' data-target='dropdown1'><img src={profile} alt="" />{username}<img src={chevrot} alt="" /></a>
                            <ul id='dropdown1' className='dropdown-content'>
                                <li className="d-flex align-items-center"><p onClick={() => onClick() }>Cerrar sesión</p></li>
                            </ul>
                        </div> 
                        
                        <div onClick={()=>onClickMenuMobile()} className="d-flex navHeader justify-content-start mb-justify-content-center align-items-center display-none mb-display-flex">
                            <i className="material-icons iconMenu right">menu</i>
                        </div>
                    </div>
                    </>
                    }
                    {
                    !isActive ? null :
                    <div className="d-flex justify-content-end align-items-center w100">
                     
                        <div className="d-flex navHeader mb-display-none justify-content-around align-items-center pointer">
                            <img src={icon2} alt="" />
                            <p>Cerrar Sesión</p>
                          
                        </div> 
                        <div className="d-flex navHeader justify-content-start mb-justify-content-center align-items-center display-none mb-display-flex">
                            <i className="material-icons iconMenu right">menu</i>
                        </div>
                    </div>
                    }
                </div>


                <div className={`${classMostrarDropdown} mostrarDropdown boxMenuDropdown display-none d-flex flex-column align-items-start`}> 
                    {Object.values(localStorage.getItem("permisos") ? JSON.parse(localStorage.getItem("permisos")) : "").map((p,key) => {
                        return (
                                <div key={key+"1"} className="d-flex navHeader navHeader--Dropdown justify-content-center align-items-center pointer">                            
                                   <p onClick={()=> irFlujo(p.path)}>{p.nombre}</p>                                       
                                </div>)   
                    })}
                
                    {
                        !isLogin ?  null : <div className="d-flex navHeader navHeader--Dropdown justify-content-center align-items-center pointer">
                                            <p onClick={() => onClick()}>CERRAR SESIÓN</p>
                                        </div> 
                    }
                </div>
            </div>
        </header>

export default Header;